module.exports = __webpack_public_path__ + "img/agent.740d5779.svg";